import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginService } from '@services/login.service';
import { Wso2Service } from '@services/wso2.service';
import { RouterLink } from '@angular/router';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';

@Component({
    selector: 'app-header-sem-menu',
    templateUrl: './header-sem-menu.component.html',
    styleUrls: ['./header-sem-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, CamelCasePipe]
})
export class HeaderSemMenuComponent {
  public username: string = sessionStorage.username;

  public empresa: any = localStorage.idEmpresaLogada;

  constructor(
    private readonly loginService: LoginService,
    private readonly wso2Service: Wso2Service
  ) {
  }

  privacidadeESeguranca(): void {
    this.wso2Service.redirectToPrivacidadeESeguranca();
  }

  sairDoSistema() {
    this.loginService.logout();
  }
}
